var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('header',{staticClass:"header"},[_c('nav',[_c('ul',{staticClass:"nav__links"},[_c('li',[_c('a',{class:[
              _vm.currentPage.includes('about') ? _vm.activeClass : '',
              'notActive'
            ],attrs:{"href":"#"}},[_c('router-link',{attrs:{"to":"/","exact":""}},[_vm._v("About")])],1)]),_c('li',[_c('a',{class:[
              _vm.currentPage.includes('resume') ? _vm.activeClass : '',
              'notActive'
            ],attrs:{"href":"#"}},[_c('router-link',{attrs:{"to":"/resume","exact":""}},[_vm._v("Resume")])],1)])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }